var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"character"},[_c('img',{staticClass:"character-image",attrs:{"src":'http://i.annihil.us/u/prod/marvel/i/mg/' + _vm.character.image + '/standard_xlarge.jpg'}}),_c('h3',{staticClass:"character-alias"},[_vm._v(_vm._s(_vm.character.alias))])])
}
var staticRenderFns = []

export { render, staticRenderFns }